export default __webpack_public_path__ + "static/media/logo.b1b8c83b.png";